/**
 * ColorPalette — Displays brand color swatches with optional labels.
 */

export default function ColorPalette({ colors, showLabels }) {
  const entries = [
    { key: 'primary', label: 'Primary' }, { key: 'secondary', label: 'Secondary' },
    { key: 'accent', label: 'Accent' }, { key: 'background', label: 'BG' },
    { key: 'surface', label: 'Surface' }, { key: 'text', label: 'Text' }, { key: 'text_muted', label: 'Muted' },
  ];
  return (
    <div className="flex gap-1">
      {entries.map(({ key, label }) => {
        const hex = colors?.[key] || '#ccc';
        return (
          <div key={key} className="flex flex-col items-center" title={`${label}: ${hex}`}>
            <div className="w-6 h-6 rounded-full border border-gray-200 hover:scale-125 transition-transform cursor-default" style={{ backgroundColor: hex }} />
            {showLabels && <span className="text-[9px] text-gray-400 mt-0.5">{label}</span>}
          </div>
        );
      })}
    </div>
  );
}
